import type { Template } from "@/types";

export const PO_03_H3_V0: Template[] = [
    {
        id: "po-03-h3v0-01",
        name: "PO 01 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 56, y: 275, width: 375, height: 234, rotation: 0, imageRotation: 0 },
            { id: "2", x: 438, y: 275, width: 375, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 275, width: 375, height: 234, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-02",
        name: "PO 02 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 262, width: 413, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 420, y: 262, width: 413, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 840, y: 262, width: 412, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-03",
        name: "PO 03 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 65, y: 78, width: 497, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 395, width: 497, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 690, y: 237, width: 497, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-04",
        name: "PO 04 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 65, y: 78, width: 497, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 395, width: 497, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 626, y: 197, width: 626, height: 387, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-05",
        name: "PO 05 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 102, y: 156, width: 344, height: 233, rotation: 0, imageRotation: 0 },
            { id: "2", x: 102, y: 395, width: 344, height: 233, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 156, width: 696, height: 472, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-06",
        name: "PO 06 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 278, y: 89, width: 696, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 278, y: 471, width: 344, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 471, width: 344, height: 223, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-07",
        name: "PO 07 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 110, width: 371, height: 277, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 394, width: 371, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 110, width: 874, height: 562, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-08",
        name: "PO 08 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 58, y: 137, width: 335, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 395, width: 335, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 401, y: 137, width: 793, height: 509, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-09",
        name: "PO 09 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 114, y: 170, width: 720, height: 443, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 170, width: 298, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 395, width: 298, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-10",
        name: "PO 10 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 66, y: 237, width: 497, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 78, width: 497, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 395, width: 497, height: 309, rotation: 0, imageRotation: 0 }
        ],
    }
];